import { useState } from 'react';
import ModalWrapper from 'components/common/overlays/ModalWrapper';
import SingleBtn from 'components/common/elements/SingleBtn';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import styles from 'styles/components/common/overlays/Modal.module.scss';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { ChartInfo } from 'constants/chart/common/chartInfo';
import useModal from 'hooks/useModal';
import useChartMutation from 'hooks/chart/useChartMutation';

type TProps = {
  category: string;
  chartType: number;
  id: number;
  patientId: string | undefined;
  courseInfoId: string | undefined;
  chartRound: string | undefined;
  chartName: string | undefined;
  data: FormData;
};

const ConfirmChartRegister = ({
  category,
  chartType,
  id,
  patientId,
  courseInfoId,
  chartRound,
  chartName,
  data,
}: TProps) => {
  const { closeModal } = useModal();
  const { chartMutation } = useChartMutation();

  const [isLoading, setIsLoading] = useState(false);

  return (
    <ModalWrapper>
      <header className={styles.title_wrapper}>
        <h2 className={styles.title}>
          {ChartInfo.find((info) => info.type === chartType)?.ko} 등록
        </h2>
        <button type="button" onClick={closeModal}>
          <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      </header>
      <p>차트 이름을 확인해 주세요.</p>
      <label>
        <input
          type="text"
          name="chartName"
          value={chartName || ''}
          className={styles.input}
          style={{ marginTop: '24px' }}
          disabled={true}
        />
      </label>
      <footer className="mt24">
        <SingleBtn
          btnText="등록"
          isBtnActive={true}
          btnStyle={{
            width: '100%',
            fontSize: '14px',
          }}
          disabled={isLoading}
          onClick={() => {
            setIsLoading(true);
            chartMutation({
              category,
              id,
              data,
              patientId,
              courseInfoId,
              chartRound,
            });
          }}
        />
      </footer>
    </ModalWrapper>
  );
};

export default ConfirmChartRegister;
